import { render, staticRenderFns } from "./AreaAmministratore.vue?vue&type=template&id=0d749148&scoped=true"
import script from "./AreaAmministratore.vue?vue&type=script&lang=js"
export * from "./AreaAmministratore.vue?vue&type=script&lang=js"
import style0 from "./AreaAmministratore.vue?vue&type=style&index=0&id=0d749148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d749148",
  null
  
)

export default component.exports